import {
    DEALERBRANCHNAME_SUCCESS,
    DEALERBRANCHNAME_FAILED,
    RESET_DEALERBRANCHNAME,
    LOADING_DEALERBRANCHNAME,
    NETWORK_ERROR_DEALERBRANCHNAME
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerBranchName = () => {
    return { type: RESET_DEALERBRANCHNAME };
};

const dealerBranchName = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERBRANCHNAME });
    await dealerServices
        .post("getBranchNameList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerBranchNamesuccess(res.data));
                    break;
                default:
                    dispatch(dealerBranchNameFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERBRANCHNAME,
                payload: err
            });
        });
};
function dealerBranchNamesuccess(data) {
    return {
        type: DEALERBRANCHNAME_SUCCESS,
        payload: data
    };
}
function dealerBranchNameFailed(data) {
    return {
        type: DEALERBRANCHNAME_FAILED,
        payload: data
    };
}

export { resetDealerBranchName, dealerBranchName };
